import React from 'react';
import TaxComponent from '../../../Elements/TaxComponent';
import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../../../Enums/TabListTableCellWidthEnum';
import moneyHelper from '../../../Helpers/moneyHelper';
import JsxHelper from '../../../Helpers/JsxHelper';
import OfficeOverheadPanel from '../OfficeOverhead/OfficeOverheadPanel';
import OfficeEmployeeCostGroupSettingsPanel from '../OfficeEmployeeCostGroupSettings/OfficeEmployeeCostGroupSettingsPanel';
import OfficeCostGroupLinksPanel from '../OfficeCostGroupLinks/OfficeCostGroupLinksPanel';
import AuthService from '../../../Services/authService';
import userHelper from '../../../Helpers/userHelper';
import GroupNameComponent from '../../../Elements/GroupNameComponent';
import LookupItemText from '../../../Elements/LookupItemText';
import DataTableActionMenu from '../../../Elements/DataTable/DataTableActionMenu';

export default class OfficeItem {
  constructor(item) {
    if (item === undefined) {
      this.OfficeId = '';
      this.Name = '';
      this.OfficeGroupId = '';
      this.OfficeGroupName = '';
      this.SalesPocName = '';
      this.OperationsPocName = '';
      this.AccountingPocName = '';
      this.EvaluatorPocName = '';
      this.OfficeManagingDirectorName = '';
      this.CreditMemoApproverName = '';
      this.DefaultPaymentMethod = '';
      this.BillingCurId = '';
      this.BillingCurrencyCode = '';
      this.MaxDirectDepositAmount = '';
      this.AddressId = '';
      this.CreatedOn = '';
      this.CreatedBy = '';
      this.ModifiedOn = '';
      this.ModifiedBy = '';
      this.SalesContact = '';
      this.OverheadRate = '';
      this.PayrollTaxPct = '';
      this.CpaPayrollTaxPct = '';
      this.CpaEmpBenefitsPct = '';
      this.MarkupPercentage = '';
      this.TeamLeadDailyCost = '';
      this.ProjMgrDailyCost = '';
      this.AssistantProjMgrDailyCost = '';
      this.PanelMgrRecruiterDailyCost = '';
      this.EditDataCheckDailyCost = '';
      this.EmpBenefitsDailyCost = '';
      this.SmcostPerEval = '';
      this.VocazillaCostPerMinute = '';
      this.IvrfeeCostPerEval = '';
      this.EditorCostPerHour = '';
      this.TimeCaptureCostPerHour = '';
      this.ShippingCostPerEval = '';
      this.CardCostPerEval = '';
      this.StreamingCostPerHour = '';
      this.CdrcostPerEval = '';
      this.DvdcostPerEval = '';
      this.CaseCostPerEval = '';
      this.CaseCostPerEval1 = '';
      this.CaseCostPerEval2 = '';
      this.Dnepct = '';
      this.IcrfeeCostPerEval = '';
      this.OperationsMgrDailyCost = '';
      this.EndOfMonthCutoffDay = '';
      this.PhoneNumber = '';
      this.FaxNumber = '';
      this.OperationsContact = '';
      this.AccountingFinanceContact = '';
      this.DdprejectSurcharge = '';
      this.Vatpct = '';
      this.TaxNumber = '';
      this.UserNameSuffix = '';
      this.BankInformation = '';
      this.EvaluatorContact = '';
      this.AllowInvoiceFinalization = '';
      this.DefaultInvoiceInterestRate = '';
      this.ManagingDirector = '';
      this.CreditMemoApprover = '';
      this.MaximumOpportunityDuration = '';
      this.EvaluatorStatementDelay = '';
      this.MaximumIntervalInMonthsBetweenOpportunityEndDateAndProjectEndDate = '';
      this.ShowFulfillmentDate = '';
      this.LateFeeGracePeriodInDays = '';
      this.TipaltiFromDate = '';
      this.AddressOfficeLegalName = '';
      this.AddressStreet = '';
      this.AddressCity = '';
      this.AddressState = '';
      this.AddressCountryName = '';
      this.AddressPostalCode = '';
      this.AllowEndOfMonthAutomation = '';
      this.HighValueReportGroupId = '';
      this.UninvoicedShopsReportGroupId = '';
      this.MissedInvoiceNotificationGroupId = '';
      this.ResourceManagementManager = '';
      this.HumanResourcesManager = '';
      this.DataQualityManager = '';
      this.ResourceManagementManagerName = '';
      this.HumanResourcesManagerName = '';
      this.DataQualityManagerName = '';
      return;
    }

    this.OfficeId = item.officeId;
    this.Name = item.name;
    this.OfficeGroupId = item.officeGroupId;
    this.OfficeGroupName = item.officeGroupName;
    this.SalesPocName = item.salesPocName;
    this.OperationsPocName = item.operationsPocName;
    this.AccountingPocName = item.accountingPocName;
    this.EvaluatorPocName = item.evaluatorPocName;
    this.OfficeManagingDirectorName = item.officeManagingDirectorName;
    this.CreditMemoApproverName = item.creditMemoApproverName;
    this.DefaultPaymentMethod = item.defaultPaymentMethod;
    this.BillingCurId = item.billingCurId;
    this.BillingCurrencyCode = item.billingCurrencyCode;
    this.MaxDirectDepositAmount = item.maxDirectDepositAmount;
    this.AddressId = item.addressId;
    this.CreatedOn = item.createdOn;
    this.CreatedBy = item.createdBy;
    this.ModifiedOn = item.modifiedOn;
    this.ModifiedBy = item.modifiedBy;
    this.SalesContact = item.salesContact;
    this.OverheadRate = item.overheadRate;
    this.PayrollTaxPct = item.payrollTaxPct;
    this.CpaPayrollTaxPct = item.cpaPayrollTaxPct;
    this.CpaEmpBenefitsPct = item.cpaEmpBenefitsPct;
    this.MarkupPercentage = item.markupPercentage;
    this.TeamLeadDailyCost = item.teamLeadDailyCost;
    this.ProjMgrDailyCost = item.projMgrDailyCost;
    this.AssistantProjMgrDailyCost = item.assistantProjMgrDailyCost;
    this.PanelMgrRecruiterDailyCost = item.panelMgrRecruiterDailyCost;
    this.EditDataCheckDailyCost = item.editDataCheckDailyCost;
    this.EmpBenefitsDailyCost = item.empBenefitsDailyCost;
    this.SMCostPerEval = item.smcostPerEval;
    this.VocazillaCostPerMinute = item.vocazillaCostPerMinute;
    this.IvrfeeCostPerEval = item.ivrfeeCostPerEval;
    this.EditorCostPerHour = item.editorCostPerHour;
    this.TimeCaptureCostPerHour = item.timeCaptureCostPerHour;
    this.ShippingCostPerEval = item.shippingCostPerEval;
    this.CardCostPerEval = item.cardCostPerEval;
    this.StreamingCostPerHour = item.streamingCostPerHour;
    this.CdrcostPerEval = item.cdrcostPerEval;
    this.DvdcostPerEval = item.dvdcostPerEval;
    this.CaseCostPerEval = item.caseCostPerEval;
    this.CaseCostPerEval1 = item.caseCostPerEval1;
    this.CaseCostPerEval2 = item.caseCostPerEval2;
    this.Dnepct = item.dnepct;
    this.IcrfeeCostPerEval = item.icrfeeCostPerEval;
    this.OperationsMgrDailyCost = item.operationsMgrDailyCost;
    this.EndOfMonthCutoffDay = item.endOfMonthCutoffDay;
    this.PhoneNumber = item.phoneNumber;
    this.FaxNumber = item.faxNumber;
    this.OperationsContact = item.operationsContact;
    this.AccountingFinanceContact = item.accountingFinanceContact;
    this.DdprejectSurcharge = item.ddprejectSurcharge;
    this.Vatpct = item.vatpct;
    this.TaxNumber = item.taxNumber;
    this.UserNameSuffix = item.userNameSuffix;
    this.BankInformation = item.bankInformation;
    this.EvaluatorContact = item.evaluatorContact;
    this.AllowInvoiceFinalization = item.allowInvoiceFinalization;
    this.DefaultInvoiceInterestRate = item.defaultInvoiceInterestRate;
    this.ManagingDirector = item.managingDirector;
    this.CreditMemoApprover = item.creditMemoApprover;
    this.MaximumOpportunityDuration = item.maximumOpportunityDuration;
    this.EvaluatorStatementDelay = item.evaluatorStatementDelay;
    this.MaximumIntervalInMonthsBetweenOpportunityEndDateAndProjectEndDate =
      item.maximumIntervalInMonthsBetweenOpportunityEndDateAndProjectEndDate;
    this.ShowFulfillmentDate = item.showFulfillmentDate;
    this.LateFeeGracePeriodInDays = item.lateFeeGracePeriodInDays;
    this.TipaltiFromDate = item.tipaltiFromDate;
    this.AddressOfficeLegalName = item.addressOfficeLegalName;
    this.AddressStreet = item.addressStreet;
    this.AddressCity = item.addressCity;
    this.AddressState = item.addressState;
    this.AddressCountryName = item.addressCountryName;
    this.AddressPostalCode = item.addressPostalCode;
    this.AddressCountryId = item.addressCountryId;
    this.OfficeManagingDirectorId = item.officeManagingDirectorId;
    this.CreditMemoApproverId = item.creditMemoApproverId;
    this.TimeZoneOffset = item.timeZoneOffset;
    this.EmployeeTaxPrc = item.employeeTaxPrc;
    this.BidailyCost = item.bidailyCost;
    this.OverheadDailyCost = item.overheadDailyCost;
    this.PaymentOfficeIds = item.paymentOfficeIds ? item.paymentOfficeIds : [];
    this.PaymentOfficeNames = item.paymentOfficeNames ? item.paymentOfficeNames : [];
    this.DqContacts = item.officeContacts
      ? item.officeContacts.filter((x) => (x.type = 'FreelancerInvoicing' && x.department === 6))
      : [];
    this.RmContacts = item.officeContacts
      ? item.officeContacts.filter((x) => (x.type = 'FreelancerInvoicing' && x.department === 1))
      : [];
    this.KamContacts = item.officeContacts
      ? item.officeContacts.filter((x) => (x.type = 'FreelancerInvoicing' && x.department === 4))
      : [];
    this.BiContacts = item.officeContacts
      ? item.officeContacts.filter((x) => (x.type = 'FreelancerInvoicing' && x.department === 10))
      : [];
    this.BdContacts = item.officeContacts
      ? item.officeContacts.filter((x) => (x.type = 'FreelancerInvoicing' && x.department === 5))
      : [];
    this.HrContacts = item.officeContacts
      ? item.officeContacts.filter((x) => (x.type = 'FreelancerInvoicing' && x.department === 13))
      : [];
    this.ItContacts = item.officeContacts
      ? item.officeContacts.filter((x) => (x.type = 'FreelancerInvoicing' && x.department === 9))
      : [];
    this.MarketingContacts = item.officeContacts
      ? item.officeContacts.filter((x) => (x.type = 'FreelancerInvoicing' && x.department === 12))
      : [];
    this.FinanceContacts = item.officeContacts
      ? item.officeContacts.filter((x) => (x.type = 'FreelancerInvoicing' && x.department === 11))
      : [];
    this.AllowEndOfMonthAutomation = item.allowEndOfMonthAutomation;
    this.HighValueReportGroupId = item.highValueReportGroupId;
    this.UninvoicedShopsReportGroupId = item.uninvoicedShopsReportGroupId;
    this.MissedInvoiceNotificationGroupId = item.missedInvoiceNotificationGroupId;
    this.ResourceManagementManager = item.resourceManagementManager;
    this.HumanResourcesManager = item.humanResourcesManager;
    this.DataQualityManager = item.dataQualityManager;
    this.ResourceManagementManagerName = item.resourceManagementManagerName;
    this.HumanResourcesManagerName = item.humanResourcesManagerName;
    this.DataQualityManagerName = item.dataQualityManagerName;
  }

  static NameOfTheIdField() {
    return 'OfficeId';
  }
  static nameOfTheItemDetailList() {
    return 'Office';
  }

  static MoneyFields = [];

  static Currency() {
    return 'USD';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return 'USD';
  }

  static DateFields = ['TipaltiFromDate'];

  static BoolFields = ['ShowFulfillmentDate'];

  static editGeneralFunction = (id, user) => {
    alert('Empty function');
  };

  static editFICFunction = (id, office) => {
    alert('Empty function');
  };

  static editContactInformationFunction(id, office) {
    alert('Empty function');
  }

  static editCorporateCostsFunction = (id, user) => {
    alert('Empty function');
  };

  static editEmployeeDailyCostsFunction = (id, user) => {
    alert('Empty function');
  };

  static editVideoCostsFunction = (id, user) => {
    alert('Empty function');
  };

  static editEmployeeCostGroupSettingsFunction = (setting) => {
    alert('Empty function');
  };

  static editOfficeCostGroupLinkFunction = (link) => {
    alert('Empty function');
  };

  static getDefaultPaymentMethod(item) {
    switch (item.DefaultPaymentMethod) {
      case 'I':
        return 'International';
      case 'D':
        return 'Direct Deposit';
      case 'C':
        return 'Check';
      case 'T':
        return 'Tipalti';
      default:
        return '';
    }
  }

  static getGroupNameCellById(id) {
    return <GroupNameComponent groupId={id} />;
  }

  static getBankInformationCell(item) {
    return (
      <textarea
        className='w-100 form-control form-control-sm'
        rows={5}
        disabled={true}
        value={item.BankInformation}
      />
    );
  }

  static getViewTaxContent(item) {
    return (
      <div>
        <TaxComponent
          officeId={item.OfficeId}
          showAddNewTaxLink={true}
          entityTypeId={72}
          entityId={-1}
          showEdit={true}
        />
      </div>
    );
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      editAction: {
        label: 'Edit General',
        rolekey: 'home_offices_edit',
        onClick: (item) => OfficeItem.editGeneralFunction(item.OfficeId, item),
      },
      data: [
        { name: 'Name', label: 'Office Name' },
        { name: 'OfficeGroupName', label: 'Office Group' },
        { name: 'OfficeManagingDirectorName', label: 'Office Managing Director' },
        { name: 'BillingCurrencyCode', label: 'Office Default Currency' },
        { name: 'SalesPocName', label: 'Sales Contact' },
        { name: 'CreditMemoApproverName', label: 'Credit Memo Approver' },
        { name: OfficeItem.getDefaultPaymentMethod, label: 'Default Payment Method' },
        { name: 'OperationsPocName', label: 'Operations Contact' },
        { name: 'ShowFulfillmentDate', label: 'Show Fulfillment Date?' },
        { name: 'MaxDirectDepositAmount', label: 'Max Direct Deposit' },
        { name: 'TimeZoneOffset', label: 'TimeZone Offset to UTC (Minutes)' },
        { name: (item) => item.EmployeeTaxPrc + ' %', label: 'Employee Tax Prc' },
        { name: 'AccountingPocName', label: 'Accounting/Finance Contact' },
        { name: 'TipaltiFromDate', label: 'Tipalti From Date' },
        { name: 'TaxNumber', label: 'Tax Number' },
        { name: 'UserNameSuffix', label: 'User Name Suffix' },
        { name: 'EvaluatorPocName', label: 'Evaluator Contact' },
        {
          name: (item) => OfficeItem.getGroupNameCellById(item.MissedInvoiceNotificationGroupId),
          label: 'Missed Inv. Notif. CC Group',
        },
        {
          name: (item) => OfficeItem.getGroupNameCellById(item.HighValueReportGroupId),
          label: 'High Value Report Group',
        },
        {
          name: (item) => OfficeItem.getGroupNameCellById(item.UninvoicedShopsReportGroupId),
          label: 'Uninvoiced Shops Report Group',
        },
        { name: (item) => item.PaymentOfficeNames.join(', '), label: 'Alternate Vendor Payment Offices' },
        { name: OfficeItem.getBankInformationCell, label: 'Bank Information', width: TabListTableCellWidthEnum.Full },
      ],
    },
    {
      tabName: 'VendorInvoicingContacts',
      tabLabel: 'Vendor Invoicing Contacts',
      icon: 'fa-solid fa-address-book',
      editAction: {
        label: 'Edit Contacts',
        rolekey: 'office_inputfield_fic',
        onClick: (item) => OfficeItem.editFICFunction(item.OfficeId, item),
      },
      data: [
        {
          name: (item) => item.DqContacts.map((x) => x.fullName).join(', '),
          label: 'DQ Contacts',
        },
        {
          name: (item) => item.RmContacts.map((x) => x.fullName).join(', '),
          label: 'RM Contacts',
        },
        {
          name: (item) => item.KamContacts.map((x) => x.fullName).join(', '),
          label: 'KAM Contacts',
        },
        {
          name: (item) => item.BiContacts.map((x) => x.fullName).join(', '),
          label: 'BI Contacts',
        },
        {
          name: (item) => item.BdContacts.map((x) => x.fullName).join(', '),
          label: 'BD Contacts',
        },
        {
          name: (item) => item.HrContacts.map((x) => x.fullName).join(', '),
          label: 'HR Contacts',
        },
        {
          name: (item) => item.ItContacts.map((x) => x.fullName).join(', '),
          label: 'IT Contacts',
        },
        {
          name: (item) => item.MarketingContacts.map((x) => x.fullName).join(', '),
          label: 'Marketing Contacts',
        },
        {
          name: (item) => item.FinanceContacts.map((x) => x.fullName).join(', '),
          label: 'Finance Contacts',
        },
      ],
    },
    {
      tabName: 'ContactInformation',
      tabLabel: 'Contact Information',
      icon: 'fa-solid fa-building',
      editAction: {
        label: 'Edit Contact',
        rolekey: 'home_offices_edit',
        onClick: (item) => OfficeItem.editContactInformationFunction(item.OfficeId, item),
      },
      data: [
        { name: 'AddressOfficeLegalName', label: 'Office Legal Name', width: TabListTableCellWidthEnum.Double },
        { name: 'AddressCountryName', label: 'Country' },
        { name: 'AddressStreet', label: 'Address' },
        { name: 'AddressCity', label: 'City' },
        { name: 'AddressState', label: 'State' },
        { name: 'AddressPostalCode', label: 'Postal Code' },
        { name: 'PhoneNumber', label: 'Phone' },
        { name: 'FaxNumber', label: 'Fax Number' },
      ],
    },
    {
      tabName: 'CorporateCost',
      tabLabel: 'Corporate Cost',
      icon: '	fa-solid fa-dollar-sign',
      rolekey: 'home_offices_corp',
      editAction: {
        label: 'Edit Corporate Costs',
        rolekey: 'home_offices_edit',
        onClick: (item) => OfficeItem.editCorporateCostsFunction(item.OfficeId, item),
      },
      data: [
        { name: 'OverheadRate', label: 'Overhead Rate %' },
        { name: 'PayrollTaxPct', label: 'Pricing Payroll Tax %' },
        { name: 'EmpBenefitsDailyCost', label: 'Pricing Benefits %' },
        { name: 'CpaPayrollTaxPct', label: 'CPA Payroll Tax %' },
        { name: 'CpaEmpBenefitsPct', label: 'CPA Employee Benefits %' },
        { name: 'MarkupPercentage', label: 'Markup %' },
      ],
    },
    {
      tabName: 'CostGroupsLinks',
      tabLabel: 'Cost Groups (Hourly)',
      icon: 'fa-solid fa-users-cog',
      data: [
        {
          name: OfficeItem.getOfficeCostGroupLinksContent,
          label: '',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'EmployeeCostGroupSettings',
      tabLabel: 'Cost Group Settings',
      icon: 'fa-solid fa-cog',
      data: [
        {
          name: OfficeItem.getEmployeeCostGroupSettingsContent,
          label: '',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'EmployeeDailyCost',
      tabLabel: 'Employee Daily Cost',
      icon: 'fa-solid fa-money-check-alt',
      rolekey: 'home_offices_emp',
      editAction: {
        label: 'Edit Employee Costs',
        rolekey: 'home_offices_edit',
        onClick: (item) => OfficeItem.editEmployeeDailyCostsFunction(item.OfficeId, item),
      },
      data: [
        {
          name: 'BillingCurrencyCode',
          label: 'Currency of the following fields',
          width: TabListTableCellWidthEnum.TwoLines,
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.OperationsMgrDailyCost, item.BillingCurrencyCode),
          label: 'Operations Mgr Cost',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.TeamLeadDailyCost, item.BillingCurrencyCode),
          label: 'Senior Project Mgr Cost',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.PanelMgrRecruiterDailyCost, item.BillingCurrencyCode),
          label: 'Recruiter Cost',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.ProjMgrDailyCost, item.BillingCurrencyCode),
          label: 'Project Mgr Cost',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.EditDataCheckDailyCost, item.BillingCurrencyCode),
          label: 'Datachecker Cost',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.AssistantProjMgrDailyCost, item.BillingCurrencyCode),
          label: 'Assistant Project Mgr Cost',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.BidailyCost, item.BillingCurrencyCode),
          label: 'BI Daily Cost',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.OverheadDailyCost, item.BillingCurrencyCode),
          label: 'Overhead Daily Cost',
          rolekey: 'office_edc_ohdc',
        },
      ],
    },
    {
      tabName: 'VideoCost',
      tabLabel: 'Video Cost',
      icon: 'fa-solid fa-video',
      rolekey: 'home_offices_video',
      editAction: {
        label: 'Edit Video Costs',
        rolekey: 'home_offices_edit',
        onClick: (item) => OfficeItem.editVideoCostsFunction(item.OfficeId, item),
      },
      data: [
        {
          name: 'BillingCurrencyCode',
          label: 'Currency of the following fields',
          width: TabListTableCellWidthEnum.TwoLines,
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.ShippingCostPerEval, item.BillingCurrencyCode),
          label: 'Shipping Cost',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.CaseCostPerEval, item.BillingCurrencyCode),
          label: 'Case Cost',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.EditorCostPerHour, item.BillingCurrencyCode),
          label: 'Editor Cost / Hour',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.CardCostPerEval, item.BillingCurrencyCode),
          label: 'Card Cost',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.CaseCostPerEval1, item.BillingCurrencyCode),
          label: 'Single Case Cost',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.TimeCaptureCostPerHour, item.BillingCurrencyCode),
          label: 'Time Capture Cost / Hour',
        },
        { name: (item) => moneyHelper.toMoneyFormat(item.CdrcostPerEval, item.BillingCurrencyCode), label: 'CDR cost' },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.CaseCostPerEval2, item.BillingCurrencyCode),
          label: 'Double Case Cost',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.StreamingCostPerHour, item.BillingCurrencyCode),
          label: 'Streaming Cost / Hour',
        },
        { name: (item) => moneyHelper.toMoneyFormat(item.DvdcostPerEval, item.BillingCurrencyCode), label: 'DVD Cost' },
        { name: 'Dnepct', label: 'DNE %' },
      ],
    },
    {
      tabName: 'Tax',
      tabLabel: 'Tax',
      icon: 'fa-solid fa-percent',
      rolekey: 'home_offices_tax',
      data: [{ name: OfficeItem.getViewTaxContent, label: 'Tax', width: TabListTableCellWidthEnum.Table }],
    },
    {
      tabName: 'OfficeOverhead',
      tabLabel: 'Office Overhead',
      icon: 'fa-solid fa-chart-line',
      rolekey: 'tablistable_officeoverhead',
      data: [{ name: OfficeItem.GetOfficeOverhead, label: '', width: TabListTableCellWidthEnum.Table }],
    },
  ];

  static GetOfficeOverhead(item) {
    return <OfficeOverheadPanel OfficeId={item.OfficeId} />;
  }

  static getEmployeeCostGroupSettingsContent(item) {
    return (
      <OfficeEmployeeCostGroupSettingsPanel
        officeId={item.OfficeId}
        editFunction={OfficeItem.editEmployeeCostGroupSettingsFunction}
      />
    );
  }

  static getOfficeCostGroupLinksContent(item) {
    return (
      <OfficeCostGroupLinksPanel
        officeId={item.OfficeId}
        // The hourly costs are stored in the office's billing currency, but the link rows carry no
        // currency of their own, so it comes from the office alongside the office id.
        currencyCode={item.BillingCurrencyCode}
        editFunction={OfficeItem.editOfficeCostGroupLinkFunction}
      />
    );
  }

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show
  //   if type is FieldTypesEnum.FunctionField then it is the function
  //   In the following example the FreelancerUserItem.editFunction function is a static variable in this class, so you can change its value
  //   I change the value in the constructor of the FreelancerUserAdmin component
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Office Id',
        orderById: 'OfficeId',
        data: 'OfficeId',
        type: FieldTypesEnum.DataFieldWithDetails,
        width: TabListTableCellWidthEnum.Table,
      },
      { label: 'Office Name', orderById: 'OfficeId', data: 'Name', width: TabListTableCellWidthEnum.Table },
      { label: 'Office Group', orderById: 'OfficeId', data: 'OfficeGroupName', width: TabListTableCellWidthEnum.Table },
      { label: 'Sales POC', orderById: 'OfficeId', data: 'SalesPocName', width: TabListTableCellWidthEnum.Table },
      {
        label: 'Operations POC',
        orderById: 'OfficeId',
        data: 'OperationsPocName',
        minWidth: 105,
        width: TabListTableCellWidthEnum.Table,
      },
      {
        label: 'Accounting POC',
        orderById: 'OfficeId',
        data: 'AccountingPocName',
        width: TabListTableCellWidthEnum.Table,
      },
      {
        label: 'Evaluator POC',
        orderById: 'OfficeId',
        data: 'EvaluatorPocName',
        width: TabListTableCellWidthEnum.Table,
      },
      {
        label: 'Managing Director',
        orderById: 'OfficeId',
        data: 'OfficeManagingDirectorName',
        minWidth: 140,
        width: TabListTableCellWidthEnum.Table,
      },
      {
        label: 'Credit Memo Approver',
        orderById: 'OfficeId',
        data: 'CreditMemoApproverName',
        minWidth: 145,
        width: TabListTableCellWidthEnum.Table,
      },
      {
        label: 'RM POC',
        orderById: 'OfficeId',
        data: 'ResourceManagementManagerName',
        minWidth: 145,
        width: TabListTableCellWidthEnum.Table,
      },
      {
        label: 'HR POC',
        orderById: 'OfficeId',
        data: 'HumanResourcesManagerName',
        minWidth: 145,
        width: TabListTableCellWidthEnum.Table,
      },
      {
        label: 'DQ POC',
        orderById: 'OfficeId',
        data: 'DataQualityManagerName',
        minWidth: 145,
        width: TabListTableCellWidthEnum.Table,
      },
    ];
  }
}
